import { render, staticRenderFns } from "./LeadershipCouncilBanner.vue?vue&type=template&id=3b0647ac&scoped=true"
import script from "./LeadershipCouncilBanner.vue?vue&type=script&lang=js"
export * from "./LeadershipCouncilBanner.vue?vue&type=script&lang=js"
import style0 from "./LeadershipCouncilBanner.vue?vue&type=style&index=0&id=3b0647ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0647ac",
  null
  
)

export default component.exports